/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated';
import { addDependencies } from './dependenciesAdd.generated';
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated';
import { smallerDependencies } from './dependenciesSmaller.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createIntersect } from '../../factoriesAny.js';
export var intersectDependencies = {
  absDependencies: absDependencies,
  addDependencies: addDependencies,
  addScalarDependencies: addScalarDependencies,
  divideScalarDependencies: divideScalarDependencies,
  equalScalarDependencies: equalScalarDependencies,
  matrixDependencies: matrixDependencies,
  multiplyDependencies: multiplyDependencies,
  multiplyScalarDependencies: multiplyScalarDependencies,
  smallerDependencies: smallerDependencies,
  subtractDependencies: subtractDependencies,
  typedDependencies: typedDependencies,
  createIntersect: createIntersect
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesIntersect.generated.js
// module id = 1430
// module chunks = 0